export const login_page_meta = {
  document_title: "登录 - 明森 ERP",
  product_name: "明森 ERP",
  product_caption: "标签印刷与不干胶原料专业管理系统",
  wordmark: "MSSOFT",
  slogan: "把复杂业务，做得清楚而高效。",
  copyright: "© 2026 广州明森软件科技有限公司",
} as const;
